import { ReactNode } from "react";

import { Briefcase } from "@phosphor-icons/react";
import { Input, Label } from "@reactive-resume/ui";

import { useCoverLetterStore } from "@/client/stores/cover-letter";
import { CLCollapsibleSection } from "../../CollapsibleSection";

export const ReferenceSection = () => {
  const setValue = useCoverLetterStore((state) => state.setValue);
  const reference = useCoverLetterStore((state) => state.coverLetter.data.reference);

  const headerHTML: ReactNode = (
    <div className="flex items-center gap-x-4">
      <Briefcase size={18} />
      <h2 className="line-clamp-1 text-base font-bold text-gray-800 lg:text-xl">Reference</h2>
    </div>
  );

  const contentHTML: ReactNode = (
    <main className="grid gap-4 sm:grid-cols-2">
      <div className="space-y-1.5 sm:col-span-2">
        <Label>Job Title</Label>
        <Input
          placeholder="Senior Software Engineer"
          value={reference.jobTitle}
          onChange={(event) => setValue("reference.jobTitle", event.target.value)}
        />
      </div>

      <div className="space-y-1.5">
        <Label>Reference Number</Label>
        <Input
          placeholder="JOB-2024-001"
          value={reference.referenceNumber}
          onChange={(event) => setValue("reference.referenceNumber", event.target.value)}
        />
      </div>

      <div className="space-y-1.5">
        <Label>Source</Label>
        <Input
          placeholder="LinkedIn, Company Website, etc."
          value={reference.source}
          onChange={(event) => setValue("reference.source", event.target.value)}
        />
      </div>
    </main>
  );

  return (
    <CLCollapsibleSection id="cl-reference" header={headerHTML} content={contentHTML} />
  );
};
